import * as React from 'react';
import { IStaticPageWrapperProps, StaticPageWrapper } from 'components/static-pages/StaticPageWrapper';

export const BiometricsPage = (props:IStaticPageWrapperProps) => {
	const url = `https://pickatime.com/client?ven=11613939&event=331129&retimp&adminLogin=on&user_key=df46d958-6fdb-4b5b-94d3-2588039438d8`;	
	return (	
		<StaticPageWrapper
			backgroundImage="/res_sys/biometrics_splash.jpg" 
      backgroundRepeat="initial"
      backgroundPosition="initial"
      backgroundSize="cover" 
			{...props}
		>
			<div style={{width:'75%', backgroundColor:'rgba(255,255,255,.80)',margin:'auto', marginTop:'40px', boxShadow:'0px 2px 4px 0px rgba(0,0,0,0.25)',borderRadius:'4px'}}>
        <a href={url} target="_blank" aria-label={`Biometrics, opens new tab`}><img src="/res_sys/biometrics.png" style={{width:'100%'}}/></a>
			</div>
		</StaticPageWrapper>
	);
};

